import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';
import { SelectShowCloudAgents, selectAgentList, selectAgentsSelected } from 'store/Agents/selectors';
import Button from 'shared/ui/Button';
import { ConfigIcon } from '../../styled';
import ModalWarning from 'Common/Components/ModalWarning';
import { getAgent, unSelectAll } from 'store/Agents/actions';
import { openModal } from 'store/modals/actions';
import { MODAL_AGENT_DETAIL } from 'store/modals/modals';

const ConfigureButton = () => {
  const dispatch = useDispatch();
  const agentsSelected = useSelector(selectAgentsSelected);
  const agents = useSelector(selectAgentList);
  const showCloudAgents = useSelector(SelectShowCloudAgents);
  const id = get(agentsSelected, '[0].id', 0);
  const [showWarning, setShowWarning] = useState(false);
  const message = showCloudAgents ? 'Please select one Security Scanner' : 'Please select one Runner';
  const title = 'Configure and Run';
  const handleClick = () => {
    if (agents.length > 0) {
      if (agentsSelected.length === 1) {
        dispatch(unSelectAll());
        dispatch(getAgent(id));
        dispatch(openModal(MODAL_AGENT_DETAIL));
      } else setShowWarning(true);
    }
  };

  const onClose = () => setShowWarning(false);

  return (
    <>
      <Button variant="ghost" startIcon={ <ConfigIcon /> } title={ title } ariaLabel={ title } onClick={ handleClick } disabled={ !agents.length > 0 } />
      { showWarning && <ModalWarning onCloseCallback={ onClose } title={ title } description={ message } /> }
    </>
  );
};

export default ConfigureButton;
